import { classNames } from "primereact/utils";
import { useEffect, useState } from "react";
import { product_category } from "../../../models/Product/product_category";
import { getAllProductCategoriesService } from "../../../services/Product/ProductCategory/ProductServices";
import { UseProductContext } from "../../Context/ProductContext";
import { secondColor } from "../../environment";
import Footer from "../../Footer/Footer";
import LoadingComponent from "../../LoadingPage/LoadingComponent";
import "./CardTemplate.css";

type cardType = {
  value: string;
  label: string;
};

const CardTemplate = () => {
  const { productCategory, setProductCategory } = UseProductContext();
  const [productCategoriesData, setProductCategoriesData] = useState<
    cardType[]
  >([]);
  const parseData = (data: any) => {
    let catArr: cardType[] = [];
    if (data && data.data) {
      data.data.map((cat: product_category) =>
        catArr.push({ value: cat._id, label: cat.name })
      );
      setProductCategoriesData(catArr);
    }
  };
  useEffect(() => {
    getAllProductCategoriesService()
      .then((data) => {
        parseData(data);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <>
      {productCategoriesData.length ? (
        <div className=" flex flex-column justify-content-space-between h-full">
          <div className="wrapper-card-template">
            {productCategoriesData.map((el, x) => (
              <div
                key={x}
                className={classNames({
                  "add-product-cards": true,
                  selected: productCategory._id === el.value,
                })}
                onClick={() =>
                  setProductCategory({ _id: el.value, name: el.label })
                }
              >
                {el.label}
              </div>
            ))}
          </div>

          <div className="footer-position">
            <Footer
              backHistory="/admin"
              progressbarValue={20}
              enableNextButton={productCategory._id !== ""}
              generalColor={secondColor}
            />
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}
    </>
  );
};

export default CardTemplate;
